import { MainMenuIcon } from '@model-framework/menu';
import { MainMenuBox } from '@model-framework/menu/MenuBox';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

type Props = {
  menuSize: number;
  onClick(): void;
  text: string;
};

export const ElementDescriptionMenuButton: React.FC<Props> = ({ menuSize, onClick, text }: Props) => {
  return (
    <>
      <MainMenuBox menuSize={menuSize} isSelected={false} onClick={onClick} text={text} />
      <MainMenuIcon icon={faInfoCircle} menuSize={menuSize} />
    </>
  );
};
